import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import Shows from "@/pages/Shows";
import ShowDetail from "@/pages/ShowDetail";
import Watch from "@/pages/Watch";
import Sources from "@/pages/Sources";
import Users from "@/pages/Users";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center bg-[#FAF9F6]"><Loader2 className="animate-spin text-zinc-400" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Home />} />
            <Route path="/movies" element={<Library kind="movie" title="Movies" eyebrow="Library" />} />
            <Route path="/videos" element={<Library kind="" title="All videos" eyebrow="Library" />} />
            <Route path="/shows" element={<Shows />} />
            <Route path="/show" element={<ShowDetail />} />
            <Route path="/watch/:id" element={<Watch />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/users" element={<AdminOnly><Users /></AdminOnly>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
